import {
  createStyles,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  withStyles,
} from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import CommonLink from '../../../../common/CommonLink';
import { darken, lighten } from '@material-ui/core/styles';
import { NAVBAR_COLOR } from '../../../../../const/color-const';

const styles = createStyles(theme => ({
  menuItem: {
    [theme.breakpoints.up('md')]: {
      '&.Mui-selected': {
        color: lighten(NAVBAR_COLOR, 0.9),
      },
    },
  },
  item: {
    color: 'inherit',
  },
  subItem: {
    '& > p': {
      color: darken(NAVBAR_COLOR, 0.3),
    },
  },
}));

const AppDrawerItem = React.forwardRef((props, ref) => {
  const {
    classes,
    menuItemDefinition,
    isSubmenuOpened,
    SubmenuClosedIcon,
    SubmenuOpenedIcon,
    onClick,
    disabled,
  } = props;
  const { icon: Icon, label, labelId, values } = menuItemDefinition;
  
  const isLink = 'link' in menuItemDefinition;
  const componentLink = () => (!isLink || disabled) ? undefined : menuItemDefinition.link;
  
  return (
    <CommonLink
      decorate={false}
      to={componentLink()}
    >
      <ListItem className={classes.menuItem}
                button
                ref={ref}
                style={{ zIndex: 99999 }}
                onClick={onClick}
                selected={isSubmenuOpened}
                disabled={disabled}
      >
        {Icon &&
        <ListItemIcon className={classes.item}>
          <Icon color="inherit" />
        </ListItemIcon>
        }
        
        <ListItemText
          className={classes.subItem}
          primary={(
            labelId ?
              <FormattedMessage
                id={labelId}
                defaultMessage={label}
                values={values}
              />
              :
              label
          )}
          secondary={'subLabelId' in menuItemDefinition && (
            <FormattedMessage
              id={menuItemDefinition.subLabelId}
              defaultMessage={menuItemDefinition.subLabel}
            />
          )}
        />
        
        {'submenu' in menuItemDefinition && (
          <ListItemSecondaryAction>
            {isSubmenuOpened ? <SubmenuOpenedIcon /> : <SubmenuClosedIcon />}
          </ListItemSecondaryAction>
        )}
      </ListItem>
    </CommonLink>
  );
});

export default withStyles(styles, { name: 'AppDrawerItem' })(AppDrawerItem);
